<template>
  <div class="tag-view-edit component">
    <div class="content editmode" v-if="editmode">
      <input type="text" v-model="nameCopy">
      <md-button :disabled="loading" @click="updateItem">save</md-button>
      <md-button @click="onCancel">cancel</md-button>
      <md-button @click="removeItem">delete</md-button>
    </div>

    <div class="content readmode" v-else>
      <div @dblclick="editmode = true">{{ item.name }}</div>
    </div>

  </div>
</template>

<script>
  import * as tagService from '../../services/tags.service'

  export default {
    name: 'TagViewEdit',
    props: {
      item: {
        type: Object
      }
    },
    watch: {},
    data () {
      return {
        loading: false,
        editmode: false,
        nameCopy: this.item.name
      }
    },
    methods: {
      onCancel () {
        this.editmode = false
        this.nameCopy = this.item.name
      },
      updateItem () {
        this.item.name = this.nameCopy
        this.loading = true
        tagService.update(this.item.id, {name: this.item.name})
          .then(response => {
            this.$emit('tag-updated')
            this.$snotify.success('Tag is updated', 'All done!')
          })
          .catch(error => {
            this.$snotify.error(error.message, 'Error')
            console.log(error)
          }).finally(() => { this.loading = false })
      },
      removeItem () {
        tagService.remove(this.item.id)
          .then(response => {
            this.$emit('tag-deleted')
            this.$snotify.success('Tag is deleted', 'All done!')
          }).catch(error => {
            this.$snotify.error(error.message, 'Error')
            console.log(error)
          })
      }
    },
    computed: {}
  }
</script>

<style lang="scss" scoped>
  .tag-view-edit.component {
    .content {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .edit, .save {
        cursor: pointer;
        padding: 0 2px;
      }
      &.readmode {
        height: 52px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/profile/TagViewEdit.vue